module.exports = ".integrations-container {\n  margin-left: 5px;\n}\n"